$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');

  $(
    'select[name=small_cart_default_payment], select[name=takeaway_printer]'
  ).select2({
    theme: 'bootstrap4',
  });

  if (p === 'organizer' && a === 'new') {
    if (window.innerWidth <= 768) {
      $('header, footer').hide();
    }
  }

  if (p === 'organizer_settings_users') {
    // Initialize selectpicker first
    $('.selectpicker').selectpicker({
      countSelectedText: function (numSelected, numTotal) {
        return numSelected + ' moduler';
      },
    });
  }
});
